/** A4 page width in twips (1/20 pt). */
const pageWidth = 11906

/** Page margins in twips, the same 30 pt as in the PDF. */
export const pageMargin = 600

/** Width of the text area between the page margins in twips. */
export const contentWidth = pageWidth - 2 * pageMargin

/** Width of the empty gap column between the two halves of the skill and language tables. */
export const tableGapWidth = 400

/** Font sizes in half points, the same as in the PDF: 11.8 pt rounded for item rows, 10 pt for details. */
export const fontSize = { body: 24, small: 20 }

/** Space after each CV item in twips, the same 20 pt as in the PDF. */
export const itemSpacing = 400
